export default __webpack_public_path__ + "0b76cec3c98dd26cffc688f0bb579af3.jpg";